import axios from 'axios';

// Base URL for the API - use environment variable or fallback
const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

// Create axios instance initially without authentication
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Function to set auth credentials
export const setAuthCredentials = (username, password) => {
  console.log(`Setting auth credentials: username=${username}, password=${password ? 'provided' : 'empty'}`);
  api.defaults.auth = {
    username,
    password
  };
};

// API functions
export const fetchRentals = async (profile = 'timur') => {
  try {
    const response = await api.get('/list-rentals', {
      params: { profile }
    });
    return response.data.data.rentals;
  } catch (error) {
    console.error(`Error fetching rentals for profile ${profile}:`, error);
    throw error;
  }
};

export const createTrip = async (data) => {
  try {
    const response = await api.post('/create-trip', data);
    return response.data.data;
  } catch (error) {
    console.error('Error creating trip:', error);
    throw error;
  }
};

export default api;